import { TroubleshootingLabel } from '../types';
import { CDN_ACCOUNT_SETTINGS_URL } from '../enum/FlagshipConstant';
import { logErrorSprintf, sprintf } from '../utils/utils';
import { LogLevel } from '../enum/LogLevel';
import { Troubleshooting } from '../hit/Troubleshooting.ts';
export class ApiSdkManager {
    _httpClient;
    _config;
    _trackingManager;
    _EAIConfig;
    _flagshipInstanceId;
    constructor({ httpClient, sdkConfig, trackingManager, flagshipInstanceId }) {
        this._httpClient = httpClient;
        this._config = sdkConfig;
        this._trackingManager = trackingManager;
        this._flagshipInstanceId = flagshipInstanceId;
    }
    resetSdk() {
        this._EAIConfig = undefined;
    }
    getBucketingContent() {
        return undefined;
    }
    sendTroubleshooting(accountSettings, url, response, now) {
        const troubleshooting = new Troubleshooting({
            flagshipInstanceId: this._flagshipInstanceId,
            label: TroubleshootingLabel.ACCOUNT_SETTINGS,
            logLevel: LogLevel.DEBUG,
            visitorId: this._flagshipInstanceId,
            config: this._config,
            accountSettings,
            traffic: 0,
            httpRequestMethod: 'POST',
            httpRequestUrl: url,
            httpResponseHeaders: response?.headers,
            httpResponseCode: response?.status,
            httpResponseTime: Date.now() - now
        });
        this._trackingManager.initTroubleshootingHit = troubleshooting;
    }
    sendErrorTroubleshooting(url, error, now) {
        const troubleshootingHit = new Troubleshooting({
            visitorId: this._flagshipInstanceId,
            flagshipInstanceId: this._flagshipInstanceId,
            label: TroubleshootingLabel.ACCOUNT_SETTINGS_ERROR,
            traffic: 0,
            logLevel: LogLevel.ERROR,
            config: this._config,
            httpRequestMethod: 'POST',
            httpRequestUrl: url,
            httpResponseBody: error?.message,
            httpResponseHeaders: error?.headers,
            httpResponseCode: error?.status,
            httpResponseTime: Date.now() - now
        });
        this._trackingManager.initTroubleshootingHit = troubleshootingHit;
    }
    async initSdk() {
        const now = Date.now();
        const url = sprintf(CDN_ACCOUNT_SETTINGS_URL, this._config.envId);
        try {
            const response = await this._httpClient.getAsync(url);
            this._EAIConfig = response.body.accountSettings;
            this.sendTroubleshooting(response.body.accountSettings, url, response, now);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        catch (error) {
            logErrorSprintf(this._config, 'Error while fetching EAI config: {0}', error?.message || error);
            this.sendErrorTroubleshooting(url, error, now);
        }
    }
    getEAIConfig() {
        return this._EAIConfig;
    }
}
